import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, field, StringDecoder } from '@common/encoding';
import { OrganizationSimple } from '../OrganizationSimple.js';
export class EmailAddressSettings extends AutoEncoder {
    email;
    unsubscribedMarketing;
    unsubscribedAll;
    hardBounce = false;
    markedAsSpam = false;
    organization = null;
}
__decorate([
    field({ decoder: StringDecoder })
], EmailAddressSettings.prototype, "email", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], EmailAddressSettings.prototype, "unsubscribedMarketing", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], EmailAddressSettings.prototype, "unsubscribedAll", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 385 })
], EmailAddressSettings.prototype, "hardBounce", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 385 })
], EmailAddressSettings.prototype, "markedAsSpam", void 0);
__decorate([
    field({ decoder: OrganizationSimple, nullable: true })
], EmailAddressSettings.prototype, "organization", void 0);
//# sourceMappingURL=EmailAddressSettings.js.map